// src/job/job-types/job-type.ts
var JOB_TYPES = Object.freeze({
  HubspotDispatchCustomers: "HubspotDispatchCustomers",
  HubspotImportCustomer: "HubspotImportCustomer",
  HubspotImportDeal: "HubspotImportDeal",
  HubspotDispatchContracts: "HubspotDispatchContracts",
  HubspotImportContract: "HubspotImportContract",
  StripeExportInvoice: "StripeExportInvoice",
  NetSuiteExportInvoice: "NetSuiteExportInvoice",
  NetSuiteExportSalesOrder: "NetSuiteExportSalesOrder",
  NetSuiteExportInvoiceSalesOrder: "NetSuiteExportInvoiceSalesOrder",
  LinkMorningCustomer: "LinkMorningCustomer",
  LinkNetSuiteCustomer: "LinkNetSuiteCustomer",
  SendInvoiceEmail: "SendInvoiceEmail",
  ExportInvoice: "ExportInvoice",
  NetSuiteDispatchPayments: "NetSuiteDispatchPayments",
  NetSuiteImportPayment: "NetSuiteImportPayment",
  UpdateInvoiceBillingStatus: "UpdateInvoiceBillingStatus",
  QuickBooksExportInvoice: "QuickBooksExportInvoice",
  QuickBooksDispatchPayments: "QuickBooksDispatchPayments",
  QuickBooksImportPayment: "QuickBooksImportPayment",
  MarketplaceExportUsage: "MarketplaceExportUsage",
  XeroImportPayment: "XeroImportPayment",
  XeroExportInvoice: "XeroExportInvoice",
  ExtractContractFromPdf: "ExtractContractFromPdf",
  XeroExportCreditMemo: "XeroExportCreditMemo",
  QuickBooksExportCreditMemo: "QuickBooksExportCreditMemo",
  NetSuiteExportCreditMemo: "NetSuiteExportCreditMemo",
  PaddleExportInvoice: "PaddleExportInvoice",
  StripeWebhookCustomerCreated: "StripeWebhookCustomerCreated",
  StripeWebhookInvoiceUpdated: "StripeWebhookInvoiceUpdated",
  StripeWebhookPaymentIntent: "StripeWebhookPaymentIntent"
});

// src/job/job-types/job-type-labels.ts
var JOB_TYPE_LABELS = {
  [JOB_TYPES.HubspotDispatchCustomers]: "HubSpot dispatch customers",
  [JOB_TYPES.HubspotImportCustomer]: "HubSpot import customer",
  [JOB_TYPES.HubspotImportDeal]: "HubSpot import deal",
  [JOB_TYPES.HubspotDispatchContracts]: "HubSpot dispatch contracts",
  [JOB_TYPES.HubspotImportContract]: "HubSpot import contract",
  [JOB_TYPES.StripeExportInvoice]: "Stripe export invoice",
  [JOB_TYPES.NetSuiteExportInvoice]: "NetSuite export invoice",
  [JOB_TYPES.NetSuiteExportSalesOrder]: "NetSuite export sales order",
  [JOB_TYPES.NetSuiteExportInvoiceSalesOrder]: "NetSuite export invoice sales order",
  [JOB_TYPES.LinkMorningCustomer]: "Link Morning customer",
  [JOB_TYPES.LinkNetSuiteCustomer]: "Link NetSuite customer",
  [JOB_TYPES.SendInvoiceEmail]: "Send invoice email",
  [JOB_TYPES.ExportInvoice]: "Export invoice",
  [JOB_TYPES.NetSuiteDispatchPayments]: "NetSuite dispatch payments",
  [JOB_TYPES.NetSuiteImportPayment]: "NetSuite import payment",
  [JOB_TYPES.UpdateInvoiceBillingStatus]: "Update invoice billing status",
  [JOB_TYPES.QuickBooksExportInvoice]: "QuickBooks export invoice",
  [JOB_TYPES.QuickBooksDispatchPayments]: "QuickBooks dispatch payments",
  [JOB_TYPES.QuickBooksImportPayment]: "QuickBooks import payment",
  [JOB_TYPES.MarketplaceExportUsage]: "Marketplace export usage",
  [JOB_TYPES.XeroImportPayment]: "Xero import payment",
  [JOB_TYPES.XeroExportInvoice]: "Xero export invoice",
  [JOB_TYPES.ExtractContractFromPdf]: "Extract contract from PDF",
  [JOB_TYPES.XeroExportCreditMemo]: "Xero export credit memo",
  [JOB_TYPES.QuickBooksExportCreditMemo]: "QuickBooks export credit memo",
  [JOB_TYPES.NetSuiteExportCreditMemo]: "NetSuite export credit memo",
  [JOB_TYPES.PaddleExportInvoice]: "Paddle export invoice",
  [JOB_TYPES.StripeWebhookCustomerCreated]: "Stripe customer received",
  [JOB_TYPES.StripeWebhookInvoiceUpdated]: "Stripe invoice update received",
  [JOB_TYPES.StripeWebhookPaymentIntent]: "Stripe payment received"
};

// src/job/job-types/job-status.ts
var JOB_STATUSES = Object.freeze({
  Pending: "Pending",
  InProgress: "InProgress",
  Completed: "Completed",
  Failed: "Failed",
  PartiallyCompleted: "PartiallyCompleted"
});

// src/job-task/job-task-types/job-task-status.ts
import { z } from "zod";
var JOB_TASK_STATUSES = Object.freeze({
  Pending: "Pending",
  InProgress: "InProgress",
  Completed: "Completed",
  Failed: "Failed",
  Skipped: "Skipped",
  Blocked: "Blocked"
});
var JobTaskStatusSchema = z.nativeEnum(JOB_TASK_STATUSES);

// src/job-task/job-task-types/job-task-type.ts
import { z as z2 } from "zod";
var JOB_TASK_TYPES = Object.freeze({
  HubspotDispatchCustomers: "HubspotDispatchCustomers",
  HubspotImportCustomer: "HubspotImportCustomer",
  HubspotImportDeal: "HubspotImportDeal",
  HubspotDispatchContracts: "HubspotDispatchContracts",
  HubspotImportContract: "HubspotImportContract",
  StripeExportInvoice: "StripeExportInvoice",
  StripeExportCustomer: "StripeExportCustomer",
  NetSuiteExportInvoice: "NetSuiteExportInvoice",
  NetSuiteExportCustomer: "NetSuiteExportCustomer",
  NetSuiteExportUsageEventsReport: "NetSuiteExportUsageEventsReport",
  LinkMorningCustomer: "LinkMorningCustomer",
  LinkNetSuiteCustomer: "LinkNetSuiteCustomer",
  NetsuiteExportSalesOrder: "NetsuiteExportSalesOrder",
  NetSuiteExportInvoiceSalesOrder: "NetSuiteExportInvoiceSalesOrder",
  SendInvoiceEmail: "SendInvoiceEmail",
  QuickBooksExportInvoice: "QuickBooksExportInvoice",
  MorningExportInvoice: "MorningExportInvoice",
  NetSuiteDispatchPayments: "NetSuiteDispatchPayments",
  NetSuiteImportPayment: "NetSuiteImportPayment",
  UpdateInvoiceBillingStatus: "UpdateInvoiceBillingStatus",
  QuickBooksDispatchPayments: "QuickBooksDispatchPayments",
  QuickBooksImportPayment: "QuickBooksImportPayment",
  MarketplaceExportUsage: "MarketplaceExportUsage",
  XeroExportInvoice: "XeroExportInvoice",
  XeroImportPayment: "XeroImportPayment",
  ExtractContractFromPdf: "ExtractContractFromPdf",
  XeroExportCreditMemo: "XeroExportCreditMemo",
  QuickBooksExportCreditMemo: "QuickBooksExportCreditMemo",
  NetSuiteExportCreditMemo: "NetSuiteExportCreditMemo",
  PaddleExportInvoice: "PaddleExportInvoice",
  StripeWebhookCustomerCreated: "StripeWebhookCustomerCreated",
  StripeWebhookInvoiceUpdated: "StripeWebhookInvoiceUpdated",
  StripeWebhookPaymentIntent: "StripeWebhookPaymentIntent"
});
var JobTaskTypeSchema = z2.nativeEnum(JOB_TASK_TYPES);

// src/job-task/job-task-types/job-task-type-labels.ts
var JOB_TASK_TYPE_LABELS = {
  [JOB_TASK_TYPES.HubspotDispatchCustomers]: "HubSpot dispatch customers",
  [JOB_TASK_TYPES.HubspotImportCustomer]: "HubSpot import customer",
  [JOB_TASK_TYPES.HubspotImportDeal]: "HubSpot import deal",
  [JOB_TASK_TYPES.HubspotDispatchContracts]: "HubSpot dispatch contracts",
  [JOB_TASK_TYPES.HubspotImportContract]: "HubSpot import contract",
  [JOB_TASK_TYPES.StripeExportInvoice]: "Stripe export invoice",
  [JOB_TASK_TYPES.StripeExportCustomer]: "Stripe export customer",
  [JOB_TASK_TYPES.NetSuiteExportInvoice]: "NetSuite export invoice",
  [JOB_TASK_TYPES.NetSuiteExportCustomer]: "NetSuite export customer",
  [JOB_TASK_TYPES.NetSuiteExportUsageEventsReport]: "NetSuite export usage events report",
  [JOB_TASK_TYPES.LinkMorningCustomer]: "Link Morning customer",
  [JOB_TASK_TYPES.LinkNetSuiteCustomer]: "Link NetSuite customer",
  [JOB_TASK_TYPES.NetsuiteExportSalesOrder]: "NetSuite export sales order",
  [JOB_TASK_TYPES.NetSuiteExportInvoiceSalesOrder]: "NetSuite export invoice sales order",
  [JOB_TASK_TYPES.SendInvoiceEmail]: "Send invoice email",
  [JOB_TASK_TYPES.QuickBooksExportInvoice]: "QuickBooks export invoice",
  [JOB_TASK_TYPES.MorningExportInvoice]: "Morning export invoice",
  [JOB_TASK_TYPES.NetSuiteDispatchPayments]: "NetSuite dispatch payments",
  [JOB_TASK_TYPES.NetSuiteImportPayment]: "NetSuite import payment",
  [JOB_TASK_TYPES.UpdateInvoiceBillingStatus]: "Update invoice billing status",
  [JOB_TASK_TYPES.QuickBooksDispatchPayments]: "QuickBooks dispatch payments",
  [JOB_TASK_TYPES.QuickBooksImportPayment]: "QuickBooks import payment",
  [JOB_TASK_TYPES.MarketplaceExportUsage]: "Marketplace export usage",
  [JOB_TASK_TYPES.XeroExportInvoice]: "Xero export invoice",
  [JOB_TASK_TYPES.XeroImportPayment]: "Xero import payment",
  [JOB_TASK_TYPES.ExtractContractFromPdf]: "Extract contract from PDF",
  [JOB_TASK_TYPES.XeroExportCreditMemo]: "Xero export credit memo",
  [JOB_TASK_TYPES.QuickBooksExportCreditMemo]: "QuickBooks export credit memo",
  [JOB_TASK_TYPES.NetSuiteExportCreditMemo]: "NetSuite export credit memo",
  [JOB_TASK_TYPES.PaddleExportInvoice]: "Paddle export invoice",
  [JOB_TASK_TYPES.StripeWebhookCustomerCreated]: "Stripe customer received",
  [JOB_TASK_TYPES.StripeWebhookInvoiceUpdated]: "Stripe invoice update received",
  [JOB_TASK_TYPES.StripeWebhookPaymentIntent]: "Stripe payment received"
};
export {
  JOB_STATUSES,
  JOB_TASK_STATUSES,
  JOB_TASK_TYPES,
  JOB_TASK_TYPE_LABELS,
  JOB_TYPES,
  JOB_TYPE_LABELS,
  JobTaskStatusSchema,
  JobTaskTypeSchema
};
